<template>
    <web-modal id="quiz">
        <template slot="content">
            <span class="new-headline-sm text-centered text-bold">Sind Sie sicher, dass Sie nicht mit der Studie fortfahren möchten?</span>
            
            <div class="btn-group">
                <v-button
                    modal-target="dismiss"
                    variant="secondary"
                    label="Nein, fortfahren"
                ></v-button>

                <v-button href="/" label="Ja, sicher"></v-button>
            </div>
        </template>
    </web-modal>
</template>

<script>
    export default {

    }
</script>
